/** Dispatch radius ladder in metres (README section 1, step 6). */
export const DISPATCH_RADII_METERS = [3_000, 5_000, 8_000];
export const DEFAULT_COVERAGE_RADIUS_METERS = DISPATCH_RADII_METERS[0];
/** Presentation and pricing-rule timezone; storage is always UTC (rule 6). */
export const PLATFORM_TIMEZONE = 'Europe/Bucharest';
//# sourceMappingURL=geo.js.map